import { Store } from "vuex";
import { getModule } from "vuex-module-decorators";
import ConfigModule from "@/store/modules/config";
import DocumentModule from "@/store/modules/document";
import GlobalModule from "@/store/modules/global";
import SnapshotModule from "@/store/modules/snapshot";
import BrowseModeModule from "@/store/modules/browse-mode";
import UIModule from "@/store/modules/ui";
import OnboardingModule from "@/store/modules/onboarding";

export let configStore: ConfigModule;
export let documentStore: DocumentModule;
export let uiStore: UIModule;
export let globalStore: GlobalModule;
export let snapshotStore: SnapshotModule;
export let browseModeStore: BrowseModeModule;
export let onboardingStore: OnboardingModule;

export function initializeStores(store: Store<any>): void {
  configStore = getModule(ConfigModule, store);
  documentStore = getModule(DocumentModule, store);
  uiStore = getModule(UIModule, store);
  globalStore = getModule(GlobalModule, store);
  snapshotStore = getModule(SnapshotModule, store);
  browseModeStore = getModule(BrowseModeModule, store);
  onboardingStore = getModule(OnboardingModule, store);
}

export const modules = {
  config: ConfigModule,
  document: DocumentModule,
  ui: UIModule,
  global: GlobalModule,
  snapshot: SnapshotModule,
  browseMode: BrowseModeModule,
  onboarding: OnboardingModule
};
